{
  "name": "Treo",
  "version": "1.1.510-RELEASE-0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=localhost.thehartford.com --disable-host-check",
    "proxy-dev": "ng serve --proxy-config proxy-dev.js --port 4200 --disable-host-check",
    "proxy-int": "ng serve --proxy-config proxy-int.js --port 4200 --disable-host-check",
    "start:mocks": "ng serve --port 4200 -c=mocks --disable-host-check",
    "build": "ng build --output-hashing=all --aot=true --configuration production --named-chunks=true",
    "build-jenkins": "npm install && node scripts/build.js",
    "archiver": "node scripts/archiver.js",
    "test": "node --max_old_space_size=4096 scripts/code-coverage.ts",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage --maxWorkers 2",
    "test:coverage-check": "node scripts/code-coverage.ts",
    "lint": "npm run lint-pretty && npm run lint-code && npm run lint-styles",
    "lint-code": "ng lint --fix=true",
    "lint-styles": "stylelint \"./src/app/**/*.scss\" \"./src/*.scss\" --fix=true",
    "lint-pretty": "prettier --config .prettierrc --write -l  \"src/**/*.ts\"",
    "build:stats": "ng build --stats-json",
    "analyze": "webpack-bundle-analyzer dist/stats.json"
  },
  "jest": {
    "coverageReporters": [
      "json-summary",
      "lcov",
      "text"
    ],
    "coveragePathIgnorePatterns": [
      "<rootDir>/src/config/",
      "<rootDir>/src/typings.d.ts",
      "<rootDir>/src/main.ts",
      "<rootDir>/src/environments/",
      "<rootDir>/scripts/update-build.ts",
      "<rootDir>/scripts/code-coverage.ts",
      "<rootDir>/src/app/shared/models.ts",
      "<rootDir>/src/assets/"
    ],
    "preset": "jest-preset-angular",
    "reporters": [
      "default",
      "jest-junit"
    ],
    "setupFilesAfterEnv": [
      "<rootDir>/src/setup.jest.ts"
    ],
    "testPathIgnorePatterns": [
      "<rootDir>/node_modules/",
      "<rootDir>/dist/",
      "<rootDir>/src/assets/"
    ],
    "moduleNameMapper": {
      "^hig-ng-lib$": "<rootDir>/libs/hig-ng-lib/fesm2022/hig-ng-lib.mjs",
      "^hig-ng-msal$": "<rootDir>/libs/hig-ng-msal/fesm2022/hig-ng-msal.mjs",
      "^hig-ui-kit$": "<rootDir>/libs/hig-ui-kit"
    }
  },
  "jest-junit": {
    "outputDirectory": "coverage/junit/",
    "outputName": "test.xml"
  },
  "husky": {
    "hooks": {
      "pre-push": "npm run lint && npm run test:coverage-check && node scripts/update-build.ts && git commit -a -m \"linting, coverage and version update done\""
    }
  },
  "private": true,
  "dependencies": {
    "@ag-grid-community/client-side-row-model": "^32.0.2",
    "@ag-grid-community/core": "^32.0.2",
    "@angular/animations": "21.2.4",
    "@angular/cdk": "21.2.4",
    "@angular/common": "21.2.19",
    "@angular/compiler": "21.2.19",
    "@angular/core": "21.2.19",
    "@angular/forms": "21.2.4",
    "@angular/platform-browser": "21.2.4",
    "@angular/platform-browser-dynamic": "21.2.4",
    "@angular/router": "21.2.4",
    "@azure/msal-angular": "^3.0.8",
    "@azure/msal-browser": "^3.28.1",
    "@esbuild/linux-x64": "^0.28.2",
    "@ng-select/ng-select": "^21.0.0",
    "ag-grid-angular": "^32.0.2",
    "ag-grid-community": "32.3.9",
    "angular-calendar": "^0.31.1",
    "angular-fusioncharts": "^4.0.3",
    "bootstrap": "5.3.8",
    "bootstrap-sass": "3.4.3",
    "core-js": "^3.30.2",
    "date-fns": "^4.1.0",
    "devtools-detect": "^4.0.2",
    "devtools-detector": "^2.0.25",
    "dexie": "^4.2.0",
    "dompurify": "^3.4.2",
    "file-saver": "^2.0.5",
    "font-awesome": "^4.7.0",
    "fusioncharts": "^4.2.0",
    "hig-tealium-ngx": "^0.3.0",
    "huk-angular-bindings": "^2.7.0",
    "huk-components": "^2.7.0",
    "moment": "2.30.1",
    "ng-multiselect-dropdown": "^1.0.0",
    "ng-tealium": "20.0.0-beta.1",
    "ngx-bootstrap": "20.0.2",
    "ngx-cookie-service": "^20.0.0",
    "pdf-lib": "^1.17.1",
    "rxjs": "^7.8.1",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@ag-grid-community/angular": "^32.0.2",
    "@ag-grid-community/styles": "^32.0.2",
    "@angular-devkit/build-angular": "21.2.3",
    "@angular-devkit/schematics": "21.2.3",
    "@angular-eslint/builder": "^18.4.3",
    "@angular-eslint/eslint-plugin": "^18.4.3",
    "@angular-eslint/eslint-plugin-template": "^18.4.3",
    "@angular-eslint/schematics": "^18.4.3",
    "@angular-eslint/template-parser": "^18.4.3",
    "@angular/cli": "21.2.3",
    "@angular/compiler-cli": "21.2.4",
    "@angular/language-service": "21.2.4",
    "@types/jest": "^29.5.12",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "archiver": "^6.0.1",
    "codelyzer": "^6.0.0",
    "https-proxy-agent": "^5.0.0",
    "husky": "^4.3.5",
    "jest": "^30.0.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-junit": "^16.0.0",
    "jest-localstorage-mock": "^2.4.3",
    "jest-preset-angular": "^15.0.0",
    "prettier": "^2.0.5",
    "replace-in-file": "^7.1.0",
    "serve": "^11.3.0",
    "shelljs": "^0.8.5",
    "stylelint": "^16.1.0",
    "stylelint-config-standard-scss": "^13.0.0",
    "ts-node": "~7.0.0",
    "tslint": "~6.1.0",
    "typescript": "~5.9.3",
    "webpack-bundle-analyzer": "^4.10.2",
    "xlsx": "^0.18.5"
  },
  "overrides": {
    "lodash": "~4.18.1",
    "fflate": "0.8.3"
  }
}
